// sensei-app/common/schemas/collections/parentStudentMap.js
import { z } from "zod";

const ParentStudentMapSchema = z.object({
    _id: z.string().optional(),
    parentId: z.string().describe("The _id of the parent's user document."),
    studentId: z.string().describe("The _id of the student's user document."),
    // Optional: Add metadata about the relationship if needed in the future
    // e.g., relationshipType: z.enum(['guardian', 'tutor']).default('guardian'),
    createdAt: z.coerce.date().optional(),
});

export default ParentStudentMapSchema;